import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import RoomingList from "../views/cms/RoomingList.vue";
import Signups from "../views/cms/Signups.vue";
import Home from "../views/Home.vue";

const routes: Array<RouteRecordRaw> = [
   {
      path: "/",
      name: "Home",
      component: Home,
   },
   {
      path: "/cms/login",
      name: "Login",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
         import(/* webpackChunkName: "Login" */ "../views/cms/Login.vue"),
   },
   {
      path: "/cms/roominglist/:tourId",
      name: "RoomingList",
      component: RoomingList
   },
   {
      path: "/cms/passengers/:tourId",
      name: "Signups",
      component: Signups
   },
   {
      path: "/:gtUrl/:tourId/join",
      name: "PublicSignups",
      // route level code-splitting
      // this generates a separate chunk (PublicSignups.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
         import(/* webpackChunkName: "PublicSignups" */ "../views/PublicSignups.vue"),
   },
   {
      path: "/:gtUrl/:tourId/waiver/:emailToken",
      name: "OnlineWaiver",
      // route level code-splitting
      // this generates a separate chunk (OnlineWaiver.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
         import(/* webpackChunkName: "OnlineWaiver" */ "../views/OnlineWaiver.vue"),
   },
];

const router = createRouter({
   history: createWebHistory(process.env.BASE_URL),
   routes,
});

export default router;
